<template>
  <section>
    <!-- Componentes externos -->
    <Reporte />
    <h3 class="primary--text">
      <v-icon color="primary">stop</v-icon> Finalizar
    </h3>

    <v-card>
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <!-- Template injectable de la cabecera de la tabla -->
          <template>
            <v-card-actions>
              <div>
                <h4 class="primary--text">Reporte de ficha personal</h4>
              </div>
              &nbsp; &nbsp;
              <div>
                <v-btn
                  icon
                  color="red"
                  dark
                  title="Generar reporte PDF"
                  @click="reporte()"
                >
                  <v-icon>picture_as_pdf</v-icon>
                </v-btn>
              </div>
            </v-card-actions>

            <p class="text-justify">
              Declaro que la información en la presente Ficha Personal es
              fidedigna y constituye Declaración Jurada, la misma que autorizo
              sea verificada en el momento que se considere pertinente por la Administracion de Servicios Portuarios - Bolivia,
              caso contrario me someto a las sanciones establecidas en la ley Nro. 1178 de
              Administración y Control Gubernamental y lo estipulado en el
              Reglamento Interno de Personal (RIP).
            </p>
            <v-flex xs6 sm3 v-if="estado == 1">
              <v-checkbox
                v-model="form.id_parametro_ta"
                label="Acepto"
                value="Acepto"
                :rules="[
                  v => {
                    if (v == null) return 'El campo es obligatorio.';
                    return true;
                  }
                ]"
              ></v-checkbox>
            </v-flex>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                v-if="estado == 1"
                color="primary"
                type="submit"
                :loading="loading"
                :disabled="!valid"
              >
                <v-icon dark>check</v-icon> Finalizar
              </v-btn>
            </v-card-actions>
          </template>

          <!-- Template de filas y columnas -->
        </v-card-text>
      </v-form>
    </v-card>
  </section>
</template>
<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones
import Reporte from "../dialogs/Reporte";

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false,
      estado: []
    };
  },
  mounted() {
    this.obtenerEstadoFicha();
  },
  methods: {
    async save() {
      //console.log('Finalizar::::::::::::::::::')
      let id_per;
      let user = this.$storage.get("user");

      if (this.$refs.form.validate()) {
        this.loading = true;

        if (this.$route.params.id != null) {
          let id;
          let a = this.$route.params.id;
          id_per = a;
        } else {
          const user = this.$storage.get("user");
          let b = user.id_persona;
          id_per = b;
        }

        // console.log(id_per)
        // console.log(user.id)

        try {
          this.loading = true;
          let res = await this.$service.graphql({
            query: `query{
                runQuery(consulta:"select persona.fn_estadoficha(${id_per},${user.id},37,'')"){
                  respuesta
                }
              }
						`
          });
          if (res.runQuery.respuesta[0].fn_estadoficha === 1) {
            this.$message.success();
          } else {
            this.$message.error("Ocurrió un error en la operación");
          }
          this.loading = false;
        } catch (error) {
          console.log(error);
        }

        //this.$message.success();
        this.loading = false;
        location.reload();
      }
    },
    async obtenerEstadoFicha() {
      let user = this.$storage.get("user");
      let respuesta = await this.$service.graphql({
        query: `
          query{
                  vListafichas(id_persona:${user.id_persona}){
                    rows{
                      id_persona
                      nombre
                      nro_doc
                      id_estado_ficha
                      estado_ficha
                      habilitado
                      item
                      id_unidad
                      unidad      
                    }
                  }
                }
        `
      });
      this.estados_ficha = respuesta.vListafichas.rows;
      this.estado = this.estados_ficha[0].habilitado;
      //console.log(this.estados_ficha[0].id_estado_ficha)
    },
    reporte() {
      let user = this.$storage.get("user");
      //console.log("Id persona ",user.id_persona);
      let id = 0;
      if (this.$route.params.id != null) {
        let a = this.$route.params.id;
        id = a;
      } else {
        const user = this.$storage.get("user");
        let b = user.id_persona;
        id = b;
      }
      //construyo la url
      let url;
      let nombre_reporte = "";
      let formato_doc = "output=pdf";
      let nombre_carpeta = "persona";
      //let url_carpeta = process.env.REPORTE_URL_OFICIAL.replace(/{carpeta}\//g, "");
      let url_carpeta = process.env.REPORTE_URL_OFICIAL.replace(/{carpeta}/g, nombre_carpeta);
      //let url_carpeta = process.env.REPORTE_URL_OFICIAL.replace(/{carpeta}/g, "");
      
      nombre_reporte = "rpt_ficha_personal";
      url = `${url_carpeta}${nombre_reporte}&${formato_doc}`;
      //Parametros
      // URL con parametros
      let url_parametros = `${url}&ID_PERSONA=${id}`;
      console.log(url_parametros);
      this.$bus.$emit("openDialogReporte", url_parametros);
    }
  },
  components: {
    Reporte
  }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/ficha_personal/components/Final.vue